import { render, staticRenderFns } from "./configuracaoContaSenha.vue?vue&type=template&id=62bee80f"
import script from "./configuracaoContaSenha.vue?vue&type=script&lang=js"
export * from "./configuracaoContaSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports